import React from 'react'
import style from "css/template.module.css";
import { Link } from 'react-router-dom';

function MobileSmartSolution() {
    return (
        <ul className={style.smart_solution_list}>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/allplace`}
                >
                    <div className={`${style.smart_solution_icon} ${style.allplace}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/all_place.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>all Place</p>
                        <p>하이브리드 워크를 위한 스마트 공간 예약 플랫폼</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/begate`}
                >
                    <div className={`${style.smart_solution_icon} ${style.begate}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/be_gate.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>Be Gate</p>
                        <p>클라우드 화상회의와 사내시스템을 연결하는 최적의 솔루션</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/privateConnectManager`}
                >
                    <div className={`${style.smart_solution_icon} ${style.private}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/private_connect_manager.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>Private Connect Manager</p>
                        <p>Private Connect의 운용/관리를 위한 관리자 전용 시스템</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/cmsmanager`}
                >
                    <div className={`${style.smart_solution_icon} ${style.cms}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/cms_manager.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>CMS Manager</p>
                        <p>Cisco Meeting Server의 운용/관리를 위한 관리자 전용 시스템</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/deviceOne`}
                >
                    <div className={`${style.smart_solution_icon} ${style.deviceone}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/device_one.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>DeviceOne</p>
                        <p>강의실 neat 디바이스 컨트롤 및 관리 시스템</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                // to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/deviceOne`}
                >
                    <div className={`${style.smart_solution_icon} ${style.medilink}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/medi_link.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>MediLink</p>
                        <p>원격 협진을 위한 안전한 비대면 진료 플랫폼</p>
                    </article>
                </Link>
            </li>
        </ul>
    )
}

export default MobileSmartSolution
